import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { AgencyType, DiversityType, DocumentType } from "../models/onboarding.model";
import { BaseService } from "./base.service";
import { AppSettings } from "../../app.settings";
import { isNotNullOrUndefined, isNullOrEmpty } from 'app/shared/utils/utils';

@Injectable()
export class OnboardingDocumentsService extends BaseService {

    constructor(private http: HttpClient, private configuration: AppSettings) {
        super();
    }

    getDocumentTypes(): Observable<DocumentType[]> {
        return this.http.get<DocumentType[]>(`${this.configuration.BaseUrl}Profile/Document/Type`, { headers: this.setHeaders() });
    }

    /** Download document from API */
    downloadDocument(documentId: string, supplierCode: string, version: string = ''): Observable<Blob> {
        let params = new HttpParams();
        if (version != null) {
            params = params.set('version', version);
          }
        if (supplierCode) {
          params = params.set('supplierCode', supplierCode);
        }
        const url = `${this.configuration.BaseUrl}Profile/Onboarding/DownloadDocument/${documentId}`;
        return this.http.get(url, { params, headers: this.setFileHeaders(), responseType: 'blob' });
      }

      downloadFile(documentId: string, version: string = ''): Observable<ArrayBuffer> {
        let params = new HttpParams();
        if (version != null) {
            params = params.set('version', version);
          }
        const url = `${this.configuration.BaseUrl}Profile/Onboarding/DownloadManual/${documentId}`;
        return this.http.get(url, { params, headers: this.setFileHeaders(), responseType: 'arraybuffer' });
      }

    /** Downlaods template file from API */
    downloadTemplate(documentId: string, supplierCode: string, version: string = null): Observable<Blob> {
        let params = new HttpParams();
        params = params.set('supplierCode', supplierCode);
        if (version != null) {
          params = params.set('version', version);
        }
        const url = `${this.configuration.BaseUrl}Profile/Onboarding/DownloadTemplate/${documentId}`;
        return this.http.get(url, { params, headers: this.setFileHeaders(), responseType: 'blob' });
    }
     /** Downlaods document with language from API */
     downloadDocumentByLanguage(documentType: string, language:string): Observable<Blob> {
        const url = `${this.configuration.BaseUrl}Profile/Onboarding/DownloadDocumentByLanguage/${documentType}/${language}`;
        return this.http.get(url, { headers: this.setFileHeaders(), responseType: 'blob' });
    }

    /** Downlaods template file from API */
    downloadPCFTemplate(documentId: string, supplierCode: string, version: string = ''): Observable<Blob> {
        let params = new HttpParams();
        params = params.set('supplierCode', supplierCode);
        if (version != null) {
            params = params.set('version', version);
        }
        const url = `${this.configuration.BaseUrl}Profile/Onboarding/DownloadPCFDocument/${documentId}`;
        return this.http.get(url, { params, headers: this.setFileHeaders(), responseType: 'blob' });
      }

    /** Downlaods template file from API */
    downloadBankSampleFile(countryCode: string): Observable<Blob> {
        const url = `${this.configuration.BaseUrl}Profile/Bank/DownloadBankSampleFile/${countryCode}`;
        return this.http.get(url, { headers: this.setFileHeaders(), responseType: 'blob' });
    }
}